import * as React from "react"
import Parser from 'html-react-parser'
import { useNavigate, useLocation } from 'react-router-dom'
import Box from "@mui/material/Box"
import "react-quill/dist/quill.snow.css"
import terms from './termsOfIHC.json';

function IHCTermPage() {
  const navigate = useNavigate()
  const content = terms.termsJa.contentJa ?? ""

  return (
    <Box
      sx={{
        margin: '0 auto',
        maxWidth: '800px',
        height: '100%',
        boxSizing: 'border-box',
        padding: '20px',
        whiteSpace: 'wrap',
        wordBreak: 'break-word',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box
        className="ql-editor"
        sx={{
          margin: '20px 0',
          overflowY: 'auto',
        }}
      >
        {Parser(String(content))}
      </Box>
    </Box>
  )
}

export default IHCTermPage
